export default __webpack_public_path__ + "static/media/arrow-left-2-icon.de7a0f38.svg";